import { FuelTag } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { useAppContext } from 'hooks/useAppContext';
import React, { FC, useEffect, useState } from 'react';
import Tag from '../Tag';
import { AccordionProps } from './types';

const AccordionContent: FC<AccordionProps> = ({ mainProducts, isHeader = false }) => {
  const {
    state: {
      profileSize: { isProfileSizeSmall },
    },
  } = useAppContext();

  const [headerProducts, setHeaderProducts] = useState([]);
  const [othersProductsLength, setOthersProductsLength] = useState('');
  const pageWidth = window.innerWidth;

  const makeHeaderTags = () => {
    const mainProductsLength = mainProducts?.length;
    let headerMainProducts: string[] = [];
    let othersMainProductsLength = null;

    const firstLongString = mainProducts?.slice(0, 2).find((item) => item.length >= 20);
    if (pageWidth <= 400) {
      othersMainProductsLength = `${mainProductsLength}`;
      setHeaderProducts([]);
      setOthersProductsLength(othersMainProductsLength);
      return;
    }

    if (firstLongString && isProfileSizeSmall) {
      headerMainProducts = [firstLongString];
      othersMainProductsLength = `+${mainProductsLength - 1}`;
      setHeaderProducts(headerMainProducts);
      setOthersProductsLength(othersMainProductsLength);
      return;
    }

    if (mainProductsLength >= 3) {
      headerMainProducts = mainProducts.slice(0, 2);
      othersMainProductsLength = `+${mainProductsLength - 2}`;
    }

    if (mainProductsLength === 2) {
      headerMainProducts = mainProducts.slice(0, 1);
      othersMainProductsLength = `+${mainProductsLength - 1}`;
    }

    if (mainProductsLength === 1) {
      headerMainProducts = mainProducts;
    }
    setHeaderProducts(headerMainProducts);
    setOthersProductsLength(othersMainProductsLength);
  };

  useEffect(() => {
    makeHeaderTags();
  }, [isProfileSizeSmall, pageWidth]);

  useEffect(() => {
    makeHeaderTags();
  }, []);

  if (isHeader) {
    return (
      <FuelFlex defaultProps={{ gap: 'km2' }} testId="accordion-content-box">
        {headerProducts.map((item) => (
          <Tag key={`${item}-value`} item={item} origin="header" />
        ))}
        {othersProductsLength && (
          <FuelTag label={othersProductsLength} uppercase={false} data-testid="test-usually-load-others" />
        )}
      </FuelFlex>
    );
  }
  return mainProducts?.map((item) => <Tag key={`${item}-value`} item={item} origin="content" />);
};

export default AccordionContent;
